export default "__VITE_ASSET__6wHA0sFN__"